import React from "react";
import { colors } from "../../../../common/Theme/Colors";
import { styles } from "../../../TextField/TextField/index.Style";

export const InputTextField = ({
  autoComplete,
  RenderRightContainer,
  style,
  mode,
  containerStyles,
  placeholder,
  editable = true,
  enableBackground = false,
  innerRef,
  className,
  maxLength,
  rows = 3, // default rows for textarea
  ...props
}) => {
  const TextFieldWidth = 50;

  const textInputText = {
    color: editable || enableBackground ? colors.black : colors.primary_003,
  };

  return (
    <div style={containerStyles}>
      <div>
        <textarea
          className={className}
          ref={innerRef}
          {...props}
          placeholder={placeholder}
          rows={rows}
          maxLength={500}
          style={{
            ...styles.textInput,
            ...textInputText,
            ...style,
            resize: "none",
            height: "120px",
          }}
        />
      </div>
    </div>
  );
};
